var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6905_54373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6905_54373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 26L12.6 24.575L15.175 22H8V20H15.175L12.6 17.425L14 16L19 21L14 26ZM22 20L17 15L22 10L23.4 11.425L20.825 14H28V16H20.825L23.4 18.575L22 20Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCredit);
export default __webpack_public_path__ + "static/media/ChangeCredit.08298434dc4630b7a7f4363ff855a98b.svg";
export { ForwardRef as ReactComponent };